module.exports = __webpack_public_path__ + "img/allow.272d4ddd.svg";